import React from 'react'
import { TypesMenuObjProps } from '..'
import './TypesModal.css'

const TypesModal = (props: TypesMenuObjProps) => {
return (
    <div className="types-modal-container">
    {props.setType.map(item => {
    return (
        <div className="types-modal">
            <h2 className="type-label">{item.label}:</h2>
            <pre>{item.description}</pre>
        </div>
        )
    })}
    </div>
)
}

export default TypesModal
